import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const ModalWrapper = styled.div(
  (props: { collapsed: boolean }) => css`
    display: ${props.collapsed ? 'none' : 'initial'};
  `
)

export const Wrapper = styled.div`
  display: grid;
  grid-row-gap: 1em;
`

export const BottomWrapper = styled.div<{ $isMobile: boolean }>`
  display: flex;
  gap: 1.5em;
  flex-direction: ${({ $isMobile }) => ($isMobile ? 'column' : 'row')};
  align-items: ${({ $isMobile }) => ($isMobile ? 'flex-start' : 'center')};
  justify-content: ${({ $isMobile }) =>
    $isMobile ? 'flex-start' : 'space-between'};
  margin-top: 0.5em;
  min-height: ${({ $isMobile }) => ($isMobile ? '150px' : 'auto')};
`

export const ActionButtons = styled.div<{
  $isMobile?: boolean
  $includeMarginTop?: boolean
}>`
  display: flex;
  flex: 1;
  flex-direction: ${({ $isMobile }) => ($isMobile ? 'column' : 'row')};
  gap: 1em;
  justify-content: ${({ $isMobile }) =>
    $isMobile ? 'space-between' : 'flex-end'};
  width: 100%;
  margin-top: ${({ $includeMarginTop }) => ($includeMarginTop ? '1em' : '0')};

  button {
    min-width: 100px;
  }
`

export const ScrollWrapper = styled.div<{ $isFullscreen: boolean }>`
  max-height: ${({ $isFullscreen }) => ($isFullscreen ? '80vh' : '70vh')};
  overflow-y: auto;
  margin: 1em -2em;
  padding: 1em 2em;
  display: grid;
  grid-row-gap: 1em;
`
